import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a7d7924"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shop-good-item" }
const _hoisted_2 = {
  class: "shop-title",
  style: {"border-top":"1px solid #fff"}
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "shop-goods" }
const _hoisted_5 = { class: "shop-goods-content" }
const _hoisted_6 = { class: "goods-name line--2" }
const _hoisted_7 = { class: "btn-content" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/same.png",
  alt: ""
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/del.png",
  alt: ""
}, null, -1))
const _hoisted_10 = { class: "shop-title shop-sku-title" }
const _hoisted_11 = { class: "props-name" }
const _hoisted_12 = {
  key: 0,
  class: "binding"
}
const _hoisted_13 = { class: "flex-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://static-s.theckb.com/BusinessMarket/Client/associated/bind_icon.png" }, null, -1))
const _hoisted_15 = { class: "price" }

import { t } from '@/plugins/i18n'
import { ref, onMounted, onUnmounted } from 'vue'
import useUserConfig, { ENUM_CONFIG_CODE } from '@/util/useUserConfig'
import bus from '@/util/useBus'
import { formatMoneyDirection } from '@/util/useYan'
import confirmDialog from '@/components/common/ConfirmDialog'
import { apiShopName, apiShopIcon } from '@/common/const'
import Image from '@/components/common/Image.vue'

export default /*#__PURE__*/_defineComponent({
  props: ['shopDetail', 'productList', 'height'],
  emits: ['similar', 'delete'],
  setup(__props, { emit: emits }) {

const props = __props


const [getValue] = useUserConfig(ENUM_CONFIG_CODE.API_ASSOCIATED_FLOW)
const scrollRef = ref()
// 绑定时高亮展示
const activeShopSkuId = ref('')
// 监听滚动
const scrollFn = (e: { scrollTop: number }) => {
  bus.emit('createAssociatedScroll', e.scrollTop)
}
bus.on('createAssociatedScroll', (num: number) => {
  scrollRef.value?.setScrollTop(num)
})

bus.on('createAssociatedEditProductSku', (sku) => {
  activeShopSkuId.value = sku
})

const deleteItem = () => {
  confirmDialog({
    title: t('提示3'),
    text: t('是否删除'),
    htmlNode: true,
    okText: t('确认'),
    cancelText: t('关闭'),
    closeOnClickModal: false
  }).then(() => {
    emits('delete')
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _unref(apiShopIcon)[__props.shopDetail.thirdPlatformType],
        alt: "",
        class: "logo"
      }, null, 8, _hoisted_3),
      _createElementVNode("span", null, _toDisplayString(_unref(apiShopName)[__props.shopDetail.thirdPlatformType] ?? '') + " " + _toDisplayString(_unref(t)('api商品')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(Image, {
        src: __props.shopDetail.thirdItemImage,
        alt: "",
        class: "goods-img"
      }, null, 8, ["src"]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(__props.shopDetail.thirdItemName), 1),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: "btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('similar', __props.shopDetail.thirdItemImage)))
          }, [
            _hoisted_8,
            _createElementVNode("span", null, _toDisplayString(_unref(t)('找同款')), 1)
          ]),
          _createElementVNode("div", {
            class: "btn",
            onClick: deleteItem
          }, [
            _hoisted_9,
            _createElementVNode("span", null, _toDisplayString(_unref(t)('删除')), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("span", null, _toDisplayString(_unref(t)('规格')), 1)
    ]),
    (_openBlock(), _createElementBlock("div", {
      class: "shop-sku",
      key: __props.height
    }, [
      _createVNode(_component_el_scrollbar, {
        class: "sku-scroll",
        onScroll: scrollFn,
        ref: (_value, _refs) => {
          _refs['scrollRef'] = _value
          scrollRef.value = _value
        },
        style: _normalizeStyle({height: __props.height + 'px'})
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.shopDetail.skuList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["sku-item flex-center", { odd:index%2===1,active: item.shopItemSkuId === activeShopSkuId.value }]),
              key: item.shopItemSkuId
            }, [
              _createVNode(Image, {
                src: item.thirdSkuImage || __props.shopDetail.thirdItemImage,
                alt: "",
                class: "sku-img"
              }, null, 8, ["src"]),
              _createVNode(_component_el_tooltip, {
                placement: "top-start",
                effect: "light",
                content: item.thirdItemAttribute.replaceAll(/null| /ig, '') === '' ? item.thirdSkuCode : item.thirdItemAttribute,
                "popper-class": "tool-tip-no-border"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(item.thirdItemAttribute.replaceAll(/null| /ig, '') === '' ? item.thirdSkuCode : item.thirdItemAttribute), 1)
                ]),
                _: 2
              }, 1032, ["content"]),
              (item.shopItemSkuId === activeShopSkuId.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('绑定中')) + "...", 1)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["bind-status", { 'no-bind': item.bindStatus !== 1 }])
                  }, _toDisplayString(item.bindStatus === 1 ? _unref(t)('已关联') +
        (item.skuMappingList?.filter((i) => i.productSku)?.length ?? '') : _unref(t)('未关联')), 3)),
              _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(formatMoneyDirection)(item.thirdSalePrice)), 1)
            ], 2))
          }), 128))
        ]),
        _: 1
      }, 8, ["style"])
    ]))
  ]))
}
}

})